export default __webpack_public_path__ + "static/gw2-banner-your-story-2f510a4afdef9e9d31b216675c5ebcb9.png";